// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"cf1fdfc5","40":"86ee2765","409":"bf3b5c5e","508":"cd418f14","603":"a2a145a0","634":"038fedbe","696":"8f8ef424","898":"593afa8b"}[chunkId] + ".chunk.css";
};